import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * @typedef { import('@wc/adapters/firebase/db-models').NoSQLEventReaction } NoSQLEventReaction
 */

/**
 * Toggle a reaction on an event (add if not exists, remove if exists)
 * @param {string} teamId The team id
 * @param {string} eventId The event id
 * @param {string} emoji The emoji character
 * @returns {Promise<{action: 'added'|'removed', reaction?: NoSQLEventReaction}>} Result of toggle
 */
export async function toggleReaction(teamId, eventId, emoji) {
  const userId = FirebaseAdapter().authn.getCurrentUser().uid;

  const existingReaction = await FirebaseAdapter().reactions.findUserReaction(
    teamId,
    eventId,
    userId,
    emoji,
  );

  if (existingReaction) {
    await FirebaseAdapter().reactions.removeReaction(
      teamId,
      eventId,
      existingReaction.id,
    );
    return { action: "removed" };
  } else {
    const reaction = await FirebaseAdapter().reactions.addReaction(
      teamId,
      eventId,
      userId,
      emoji,
    );
    return { action: "added", reaction };
  }
}

/**
 * Add a reaction to an event
 * @param {string} teamId The team id
 * @param {string} eventId The event id
 * @param {string} emoji The emoji character
 * @returns {Promise<NoSQLEventReaction>} The created reaction
 */
export async function addReaction(teamId, eventId, emoji) {
  const userId = FirebaseAdapter().authn.getCurrentUser().uid;
  return await FirebaseAdapter().reactions.addReaction(
    teamId,
    eventId,
    userId,
    emoji,
  );
}
